export default __webpack_public_path__ + "static/media/Rectangle-22-yono.bb85f07d.png";